import {
  FilterMode,
  TenantDocumentCreateMutationVariables,
  TenantDocument_OrderBy,
  TenantDocument,
  SortOrder,
  TenantDocument_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const tenantDocumentService = {
  createOne: buildCreateOne(
    (tenantDocumentCreateVariables: TenantDocumentCreateMutationVariables) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.tenantDocumentCreate(
          tenantDocumentCreateVariables
        );
        return result.tenantDocumentCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.tenantDocumentOne({ id });
    return result.tenantDocumentOne as TenantDocument;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: TenantDocument_OrderBy[] | null = null,
    filter: TenantDocument_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: TenantDocument_Filter | undefined;
    if (searchValue !== "") {
      where = {
        OR: [
          { name: { contains: searchValue, mode: FilterMode.Insensitive } },
          {
            description: {
              contains: searchValue,
              mode: FilterMode.Insensitive,
            },
          },
        ],
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.tenantDocumentListWithOffset({
      offset,
      take,
      orderBy: orderBy
        ? orderBy
        : [{ name: SortOrder.Asc }, { description: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.tenantDocumentListWithOffset
    ) as TenantDocument[];
    return { list, orderBy };
  },
};
